import {
    Modal,
    Button
} from "react-bootstrap";
import axios from 'axios';
import React, { useState, useEffect} from "react";

import SyncLoader from "react-spinners/SyncLoader";

const findDentistByID = (clinic, dentistID) => {
    for(let i = 0; i< clinic.dentists.length; i++){
        let dentistIndex = clinic.dentists[i];
        if (dentistIndex._id === dentistID){
            return dentistIndex;
        }
    }
    return 'The dentist was not found';
} 

const sortData = (clinic, dentist, patient) => {
    const oneHour = 60 * 60 * 1000;

    const data = {};
    data.clinic_adress      =   clinic.address;
    data.clinic_id          =   clinic._id
    data.clinic_image_urls  =   clinic.image_urls
    data.clinic_name        =   clinic.clinic_name
    data.customer_email     =   patient.email;
    data.customer_message   =   patient.message || 'No message';
    data.customer_name      =   patient.first_name + ' ' + patient.last_name;
    data.customer_phone     =   patient.phone;
    data.dentist_email      =   dentist.email
    data.dentist_id         =   dentist._id;
    data.dentist_gender     =   dentist.gender;
    data.dentist_name       =   dentist.full_name;
    data.emirate            =   clinic.emirate;
    data.end                =   new Date(patient.time.getTime() + oneHour); 
    data.price              =   patient.price;
    data.reserved           =   false;
    data.requested          =   true;
    data.start              =   patient.time;
    data.title              =   patient.treatment;
    return data;
} 

export default function BookTimeModal(props) {
    const bookingData = props.bookingData;
    const clinic = props.clinicData;
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [dentistName, setDentistName] = useState('')
    const handleClose = () => props.setShow(false);


    useEffect(() => {
        setLoading(true)
        const dentistInfo = findDentistByID(clinic, bookingData.dentist)
        setDentistName(dentistInfo.name)
        const dataToSubmit = sortData(clinic, dentistInfo, bookingData);
        console.log(dataToSubmit);
        axios.post("https://uae-dentist-backend.herokuapp.com/schedule/request-time", dataToSubmit)
        .then((result) => {
            console.log(result)
            setLoading(false);
            setSuccess(true);
        })
        .catch(function (error) {
            setSuccess(false);
            setLoading(false)
            console.log(error);
        });
            // eslint-disable-next-line
    }, []);
    
    // const onSubmit = async (data) => {
    //     console.log('Hello: ' + data);
    // }

    

        return (
          <Modal show={true} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Result</Modal.Title>
            </Modal.Header>
             <Modal.Body className='mx-auto my-3'>
            {!loading && success &&
            `Your booking request has been sent. You will recieve an email once your request has been confirmed by ${dentistName}.`}
            {!loading && !success &&
            `Something went wrong in the booking request.`}
            </Modal.Body>
            <SyncLoader size={15} margin={2} color={"#123abc"} loading={loading}/>
            <div>
            <Button className='rounded-pill h5 float-right w-25' variant="primary" onClick={handleClose} >
                Close
            </Button>
            </div>
          </Modal>  
        );
      }
    